import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import 'react-datepicker/dist/react-datepicker.css'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import Loader from '@/components/common/Loader'
import FaqAndInfo from '@/components/dashboard/FaqAndInfo'
import BookingRequestForm from '@/components/requestBooking/bookingRequestForm'

const RequestBooking = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [speakerData, setSpeakerData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const previewFlag = router.query.preview ? router.query.preview : ''
    const slugParms = { slug: router.query.slug, preview: previewFlag }
    const getSpeakerProfileData = async (reqParams) => {
      let apiParams = {}

      const slug = typeof reqParams.slug == 'string' ? reqParams.slug : reqParams.slug[0]

      if (reqParams.preview) {
        apiParams = { slug: slug, preview: true }
      } else {
        apiParams = { slug: slug }
      }

      const apiUrl = `${process.env.NEXT_PUBLIC_APIM_BASE_PATH}/speakerProfile`
      const config = {
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_APIM_SUBSCRIPTION_KEY,
        },
        params: apiParams,
      }
      try {
        await axios.get(apiUrl, config).then((res) => {
          setSpeakerData(res?.data?.data)
        })
        setIsLoading(false)
      } catch (err) {
        router.push(`/${err?.response?.status}`)
      }
    }
    if (router.query.slug) {
      getSpeakerProfileData(slugParms)
    }
  }, [router.query])

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BookingRequestForm speakerData={speakerData} booknow={false} />
          <FaqAndInfo />
        </>
      )}
    </>
  )
}

export default RequestBooking
